import { render } from "./RoleForm.vue?vue&type=template&id=8122a164&ts=true"
import script from "./RoleForm.vue?vue&type=script&lang=ts"
export * from "./RoleForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__